import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-197ce4a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_2 = {
  key: 1,
  class: "badge badge-light-info"
}
const _hoisted_3 = {
  key: 2,
  class: "badge badge-light-warning"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "m-2" }, null, -1))
const _hoisted_5 = {
  key: 3,
  class: "badge badge-light-danger"
}
const _hoisted_6 = {
  key: 4,
  class: "badge badge-light-success"
}
const _hoisted_7 = {
  key: 5,
  class: "badge badge-light-warning"
}
const _hoisted_8 = {
  key: 6,
  class: "badge badge-light-primary"
}
const _hoisted_9 = {
  key: 7,
  class: "badge badge-light-info"
}
const _hoisted_10 = {
  key: 8,
  class: "badge badge-light-dark"
}
const _hoisted_11 = {
  key: 9,
  class: "badge badge-light-secondary"
}
const _hoisted_12 = {
  key: 10,
  class: "badge badge-light-danger"
}
const _hoisted_13 = {
  key: 11,
  class: "badge badge-light-warning"
}
const _hoisted_14 = {
  key: 12,
  class: "badge badge-light-success"
}
const _hoisted_15 = {
  key: 13,
  class: "badge badge-light-primary"
}
const _hoisted_16 = {
  key: 14,
  class: "badge badge-light-info"
}
const _hoisted_17 = {
  key: 15,
  class: "badge badge-light-dark"
}
const _hoisted_18 = {
  key: 16,
  class: "badge badge-light-secondary"
}
const _hoisted_19 = {
  key: 17,
  class: "badge badge-light-danger"
}
const _hoisted_20 = {
  key: 18,
  class: "badge badge-light-warning"
}
const _hoisted_21 = {
  key: 19,
  class: "badge badge-light-success"
}
const _hoisted_22 = {
  key: 20,
  class: "badge badge-light-primary"
}
const _hoisted_23 = {
  key: 21,
  class: "badge badge-light-info"
}
const _hoisted_24 = {
  key: 22,
  class: "badge badge-light-dark"
}
const _hoisted_25 = {
  key: 23,
  class: "badge badge-light-secondary"
}
const _hoisted_26 = {
  key: 24,
  class: "badge badge-light-danger"
}
const _hoisted_27 = {
  key: 25,
  class: "badge badge-light-warning"
}
const _hoisted_28 = {
  key: 26,
  class: "badge badge-light-success"
}
const _hoisted_29 = {
  key: 27,
  class: "badge badge-light-primary"
}
const _hoisted_30 = {
  key: 28,
  class: "badge badge-light-info"
}
const _hoisted_31 = {
  key: 29,
  class: "badge badge-light-dark"
}
const _hoisted_32 = {
  key: 30,
  class: "badge badge-light-secondary"
}
const _hoisted_33 = {
  key: 31,
  class: "badge badge-light-danger"
}
const _hoisted_34 = {
  key: 32,
  class: "badge badge-light-warning"
}
const _hoisted_35 = { class: "mx-3 w-full" }
const _hoisted_36 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_37 = {
  key: 1,
  class: "badge badge-light-warning"
}
const _hoisted_38 = {
  key: 2,
  class: "badge badge-light badge-pill"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dificulty", _ctx.extraClasses])
  }, [
    (_ctx.pathway.level == 'Beginner')
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Beginner"))
      : _createCommentVNode("", true),
    (_ctx.pathway.level == 'Intermediate')
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Intermediate"))
      : _createCommentVNode("", true),
    (_ctx.pathway.level == 'Advanced')
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Advanced"))
      : _createCommentVNode("", true),
    _hoisted_4,
    (_ctx.pathway.type == 'Offensive')
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Offensive"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'General')
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, "General"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Application Security')
      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Application Security"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Defensive')
      ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Defensive"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Threat Intelligence')
      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Threat Intelligence"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Incident Response')
      ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Incident Response"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Forensics')
      ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Forensics"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Reverse Engineering')
      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Reverse Engineering"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Hardware')
      ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Hardware"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Mobile')
      ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Mobile"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Cloud')
      ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Cloud"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'IOT')
      ? (_openBlock(), _createElementBlock("span", _hoisted_16, "IOT"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Network')
      ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Network"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Web')
      ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Web"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Wireless')
      ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Wireless"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'OSINT')
      ? (_openBlock(), _createElementBlock("span", _hoisted_20, "OSINT"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Social Engineering')
      ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Social Engineering"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Malware Analysis')
      ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Malware Analysis"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Cryptography')
      ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Cryptography"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Steganography')
      ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Steganography"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Binary Analysis')
      ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Binary Analysis"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Programming')
      ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Programming"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Scripting')
      ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Scripting"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'DevOps')
      ? (_openBlock(), _createElementBlock("span", _hoisted_28, "DevOps"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Cloud Security')
      ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Cloud Security"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Management')
      ? (_openBlock(), _createElementBlock("span", _hoisted_30, "Management"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Soft Skills')
      ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Soft Skills"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Career')
      ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Career"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Certification')
      ? (_openBlock(), _createElementBlock("span", _hoisted_33, "Certification"))
      : _createCommentVNode("", true),
    (_ctx.pathway.type == 'Other')
      ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Other"))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_35, [
      _renderSlot(_ctx.$slots, "status", {}, () => [
        (_ctx.pathway.percentage_completed == 100)
          ? (_openBlock(), _createElementBlock("span", _hoisted_36, "Completed"))
          : _createCommentVNode("", true),
        (_ctx.pathway.percentage_completed > 0 && _ctx.pathway.percentage_completed < 100)
          ? (_openBlock(), _createElementBlock("span", _hoisted_37, "In progress"))
          : _createCommentVNode("", true),
        (_ctx.pathway.percentage_completed == 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_38, "Not started yet"))
          : _createCommentVNode("", true)
      ], true)
    ])
  ], 2))
}